import React from 'react';
import Icon from './Icon';
import ScrollAnimate from './ScrollAnimate';

const FrontPageServices = () => (
  <section className="front-page--section">
    <div>
      <h1 className="front-page--title front-page--title-divider">Services</h1>
      <p>
        Whether you need customization of a CMS, a REST API, or a full web application, rely on a
        professional with experience in various technologies to evaluate, select and implement the
        optimal solution. With over a decade of experience building enterprise-grade web
        applications using a number of different languages and frameworks, I have the experience to
        deliver the result you need.
      </p>
      <p>Here are some of the services if offer.</p>
    </div>
    <div className="front-page--section-block-container">
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-half"
      >
        <Icon
          type="IconSphere"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />
        <h2 className="front-page--subtitle">Front-End</h2>
        <p>
          <strong>Web UI/UX development</strong>
        </p>
        <p>
          I use modern tools and techniques to create web front-ends that load fast, are responsive
          across devices and interactive.
        </p>
        <p>
          HTML, CSS and Javascript is custom created or carefully selected from available frameworks
          and libraries based on the best fit for the desired solution.
        </p>
        <ul className="front-page--list">
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Clean and semantic HTML
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Organised and maintainable CSS
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Performant and functional JavaScript
          </li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-half"
      >
        <Icon
          type="IconEmbed"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />
        <h2 className="front-page--subtitle">Back-end</h2>
        <p>
          <strong>Custom development / CMS / Third-party integration </strong>
        </p>
        <p>
          Many solutions require server-side rendering, custom business logic or integration with
          third-party systems.
        </p>
        <p>
          I am experienced with numerous languages and frameworks. I use the correct technology to
          construct solutions that function on Linux and Microsoft Windows back-ends.
        </p>
        <ul className="front-page--list">
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Server web frameworks
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            RESTful APIs
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Third-party integrations
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            WordPress - installation / configuration / custom themes and plugins
          </li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-half"
      >
        <Icon
          type="IconDatabase"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />
        <h2 className="front-page--subtitle">Data</h2>
        <p>
          <strong>SQL / Stored Procedures / Query Plans </strong>
        </p>
        <p>
          I have significant experience implementing solutions in Oracle Database and Microsoft SQL
          Server as well as PostgreSQL and MySQL/MariaDB.
        </p>
        <p>
          And I am no stranger to schema design, stored procedures and optimizing queries for scale
          and performance.
        </p>
        <ul className="front-page--list">
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            SQL queries
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Database procedural code
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Query analysis and optimization
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Schema definition/optimization
          </li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-half"
      >
        <Icon
          type="IconCogs"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />
        <h2 className="front-page--subtitle">Infrastructure</h2>
        <p>
          <strong>Automation - provisioning, testing, deploying</strong>
        </p>
        <p>
          I design, provision and secure infrastructure based function the needs of the solution.
        </p>
        <p />
        <ul className="front-page--list">
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Automated provisioning
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            System administration
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Continuous integration/deployment
          </li>
          <li>
            <Icon
              type="IconCheckmark"
              className="front-page--list-icon"
              iconClassName=""
              height="16"
              width="16"
            />
            Web server / web cache configuration
          </li>
        </ul>
      </ScrollAnimate>
    </div>
  </section>
);

export default FrontPageServices;



// WEBPACK FOOTER //
// ./src/components/FrontPageServices.js